import * as React from "react";

import { AppContextType } from "@/context/app";

export type ProjectType = {
  id: string;
  name: string;
  status: string;
  domainName?: string;
  ipAddress?: string;
  generated?: boolean;
  sshKeysGenerated?: boolean;
  apps: AppContextType[];
  createdAt?: string;
  jobs?: unknown[];
  deployments?: {
    id: string;
    createdAt: string;
    job: string;
    status: string;
    data: Record<string, unknown>;
    project: string;
    jobId?: string;
    progress?: number;
  }[];
  edges?: {
    source: string;
    target: string;
    data?: Record<string, unknown>;
  }[];
};

export type ProjectsMap = {
  [key: string]: ProjectType;
};

export type ProjectContextType = {
  projectsMap: ProjectsMap;
  fetchProjects: () => void;
  activeProject: ProjectType | null;
  setActiveProject: (project: ProjectType | null) => void;
  setProjectsMap: (map: ProjectsMap) => void;
  recentProjects: ProjectType[];
  addRecentProject: (project: ProjectType) => void;
  isDigitalOceanConnected: boolean;
  checkDigitalOceanConnection: () => Promise<void>;
};

export const ProjectContext = React.createContext<ProjectContextType>({
  projectsMap: {},
  fetchProjects: () => {},
  activeProject: null,
  setActiveProject: () => {},
  setProjectsMap: () => {},
  recentProjects: [],
  addRecentProject: () => {},
  isDigitalOceanConnected: false,
  checkDigitalOceanConnection: async () => {},
});
